<tax-modal-header> menu.kkms </tax-modal-header>

<tax-modal-content>
  <tax-input
    class="search-input"
    [(ngModel)]="filterParam"
    (input)="updateKkmsListByParams($event)"
    placeholder="cto.modal.kkms.placeholder"
    [autofocus]="true"
    data-qa-input="search"
  ></tax-input>

  <div class="modal-body-wrapper">
    <div class="modal_body" taxScrollbar (scroll)="onElementScroll($event.target)">
      <ng-template [ngIf]="isLoaded">
        <div *ngIf="kkms.length; else empty" data-qa="retail-places">
          <div *ngFor="let retailPlace of kkms" data-qa="retail-place">
            <div class="modal_body__block">
              <div class="line-center" data-qa-checkbox="retail-place">
                <!--TODO: fix $any-->
                <input
                  type="checkbox"
                  [checked]="isRpChecked(retailPlace)"
                  (change)="rpCheckboxChange($event, $any(retailPlace).kkms)"
                  data-qa="checkbox"
                />
                <svg-icon key="pointsale"></svg-icon>
                <!--TODO: fix $any-->
                <span class="bold-text" data-qa="checkbox-label-text">{{
                  $any(retailPlace).title
                }}</span>
              </div>
              <!--TODO: fix $any-->
              <div class="grey-text" data-qa="retail-place-address">
                {{ $any(retailPlace).address }}
              </div>
            </div>
            <!--TODO: fix $any-->
            <div *ngFor="let kkm of $any(retailPlace).kkms" data-qa-block="kkm">
              <hr class="greyline" />
              <div class="extra-space modal_body__block" data-qa-checkbox="kkm">
                <div class="line-center">
                  <input
                    type="checkbox"
                    [checked]="kkm.selected"
                    (change)="kkmCheckboxChange($event, kkm.id)"
                    data-qa="checkbox"
                  />
                  <svg-icon key="kkt"></svg-icon>
                  <span data-qa="kkm-name" data-qa="checkbox-label-text">{{
                    kkm.internalName
                  }}</span>
                </div>
                <div class="grey-text">
                  <span data-qa="kkm-model">{{ kkm.model }}</span>
                  <span data-qa="kkm-serial-number"
                    >{{ 'cto.add.kkm.number' | translate }} {{ kkm.serialNumber }}</span
                  >
                  <span data-qa="kkm-id">ID: {{ kkm.id }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #empty>
          <div class="block-center" translate data-qa="empty-list-text">cto.modal.not.found</div>
        </ng-template>
      </ng-template>
      <ng-template [ngIf]="!isLoaded">
        <div class="loader-body">
          <div class="loader-block">
            <div class="loader-block-text" translate>cto.modal.loading</div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</tax-modal-content>

<tax-modal-footer>
  <button data-qa-button="close-modal" class="button_link" (click)="closeModal()" translate>
    button.cancel
  </button>
  <button data-qa-button="save" class="button_blue" (click)="saveSelectedKkm()" translate>
    modal.select
  </button>
</tax-modal-footer>
